


















import { Vue, Component, Prop } from "vue-property-decorator";
import moment from "moment";
import { lockModule } from "@/store/lock";
import {
  Lock,
  GetLockLogsResult,
  DeviceLogTypeMask,
  DeviceLogData
} from "@/../generated/iloq-api";

@Component({
  components: {}
})
export default class LockLogListEntry extends Vue {
  @Prop(Object) entry!: DeviceLogData;
  currentLog: GetLockLogsResult | null = null;
  masks = [
    { mask: DeviceLogTypeMask.NUMBER_0, value: "Unknown type" },
    { mask: DeviceLogTypeMask.NUMBER_1, value: "Failed access" },
    { mask: DeviceLogTypeMask.NUMBER_2, value: "Lock was programmed" },
    { mask: DeviceLogTypeMask.NUMBER_4, value: "Successful access" },
    { mask: DeviceLogTypeMask.NUMBER_8, value: "Phone accessed the lock" },
    { mask: DeviceLogTypeMask.NUMBER_16, value: "Fob accessed the lock" },
    { mask: DeviceLogTypeMask.NUMBER_1024, value: "Key accessed the lock" },
    {
      mask: DeviceLogTypeMask.NUMBER_2048,
      value: "5 Series key accessed the lock"
    },
    {
      mask: DeviceLogTypeMask.NUMBER_4096,
      value: "Unknown key (Key is empty or in factory state)"
    },
    { mask: DeviceLogTypeMask.NUMBER_8192, value: "Snap open access" },
    {
      mask: DeviceLogTypeMask.NUMBER_16384,
      value: "Log is a key passage from a lock which doesn't collect logs."
    }
  ];

  get key() {
    return this.entry.FNKey;
  }

  fetchLockLog(lock: Lock) {
    if (lock.FLock_ID) {
      lockModule.fetchLockLog(lock.FLock_ID).then(response => {
        this.currentLog = response;
      });
    }
  }

  getText(typeMask: number) {
    return this.masks
      .filter(mask => typeMask & mask.mask)
      .map(mask => mask.value)
      .join(", ");
  }

  get timeStamp() {
    return moment(this.entry.GoingDateUtc + "+00:00")
      .lang("sv")
      .format("lll");
  }
}
